import { RefreshCw } from 'lucide-react';
import { memo } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { ChatLayout } from './types';

interface ChatHeaderProperties {
  className?: string;
  isSyncing?: boolean | undefined;
  layout: ChatLayout;
  onStartFresh?: (() => void) | undefined;
  subtitle?: string | null;
  title?: string;
}

export const ChatHeader = memo(function ChatHeaderComponent({
  className,
  layout,
  title = 'Conversation',
  subtitle,
  onStartFresh,
  isSyncing = false,
}: ChatHeaderProperties) {
  const isSidebar = layout === 'sidebar';
  if (isSidebar) {
    return null;
  }
  return (
    <header
      className={cn(
        'flex items-center justify-between gap-3 border-b border-border/50 px-4 py-3 text-card-foreground sm:px-6',
        'bg-transparent',
        className
      )}
    >
      <div className="min-w-0">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground/70">{title}</h2>
        {subtitle ? <p className="truncate text-xs text-muted-foreground">{subtitle}</p> : null}
      </div>
      {onStartFresh ? (
        <Button
          type="button"
          size="sm"
          variant={isSidebar ? 'ghost' : 'secondary'}
          onClick={onStartFresh}
          className="flex items-center gap-1 rounded-full px-3"
        >
          <RefreshCw className="h-3.5 w-3.5" />
          <span className="text-xs font-semibold">Start fresh</span>
          {isSyncing ? <span className="text-[10px] uppercase text-muted-foreground/70">Syncing…</span> : null}
        </Button>
      ) : null}
    </header>
  );
});
